// src/context/AuthContext.js
import React, { createContext, useState, useEffect } from 'react';
import {
  getToken,
  setToken,
  logout as apiLogout, // Aliased for clarity, though 'logout' is also fine
  login as apiLogin,     // Import 'login' and alias it to 'apiLogin'
  register as apiRegister,  // Import 'register' and alias it to 'apiRegister'
  resetPassword as apiResetPassword
} from '../utils/auth';

export const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [jwt, setJwtState] = useState(null);
  const [user, setUserState] = useState(null); // Optional: manage user object

  useEffect(() => {
    const storedJwt = getToken();
    if (storedJwt) {
      setJwtState(storedJwt);
      // TODO: Optionally fetch user details here if JWT exists, using GET /api/users/me
      // and then setUserState(fetchedUser);
    }
  }, []);

  const signin = async (credentials) => { // credentials = { identifier, password }
    const response = await apiLogin(credentials); // Use aliased apiLogin
    if (response.jwt) {
      setToken(response.jwt);
      setJwtState(response.jwt);
      setUserState(response.user);
    }
    return response;
  };

  const signup = async (formData) => { // formData = { firstName, ..., newsletterConsent }
    const response = await apiRegister(formData); // Use aliased apiRegister
    if (response.success && response.jwt) {
      setToken(response.jwt);
      setJwtState(response.jwt);
      setUserState(response.user);
    }
    return response;
  };

  const signout = () => {
    apiLogout();
    setJwtState(null);
    setUserState(null);
  };

  const completePasswordReset = async (payload) => {
    const response = await apiResetPassword(payload);
    if (response.jwt) {
      setToken(response.jwt);
      setJwtState(response.jwt);
      setUserState(response.user);
    }
    return response;
  };

  return (
    <AuthContext.Provider value={{ jwt, user, signin, signup, signout, completePasswordReset }}>
      {children}
    </AuthContext.Provider>
  );
}
